module.exports = __webpack_public_path__ + "static/img/IMG_20170906_193916.d804f8c6.jpg";